var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4236_1114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12C19.9475 12 19.898 12.0135 19.847 12.015C19.9491 11.5165 20.0004 11.0089 20 10.5C20 6.3585 16.6415 3 12.5 3C8.3585 3 5 6.3585 5 10.5C5 10.5255 5.0075 10.5495 5.0075 10.575C2.4635 10.938 0.5 13.1055 0.5 15.75C0.5 17.1424 1.05312 18.4777 2.03769 19.4623C3.02226 20.4469 4.35761 21 5.75 21H9.512C9.70741 21 9.9009 20.9615 10.0814 20.8867C10.262 20.812 10.426 20.7023 10.5642 20.5642C10.7023 20.426 10.812 20.262 10.8867 20.0814C10.9615 19.9009 11 19.7074 11 19.512V15H7.817L12.5 9L17.183 15H14V19.512C14 20.334 14.666 21 15.488 21H20C20.5909 21 21.1761 20.8836 21.7221 20.6575C22.268 20.4313 22.7641 20.0998 23.182 19.682C23.5998 19.2641 23.9313 18.768 24.1575 18.2221C24.3836 17.6761 24.5 17.0909 24.5 16.5C24.5 15.9091 24.3836 15.3239 24.1575 14.7779C23.9313 14.232 23.5998 13.7359 23.182 13.318C22.7641 12.9002 22.268 12.5687 21.7221 12.3425C21.1761 12.1164 20.5909 12 20 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4236_1114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload-file-icon.5442ee61830f1b19440e9becca04d589.svg";
export { ForwardRef as ReactComponent };